import dayjs from 'dayjs';
// 转办弹窗表单配置
export const complaintFormOption = {
  column: [
    {
      type: 'select',
      label: '服务班组',
      span: 12,
      display: true,
      prop: 'group',
      formslot: true,
      disabled: true,
      required: true,
    },
    {
      type: 'select',
      label: '服务班组',
      span: 12,
      display: false,
      prop: 'groupId',
      formslot: true,
      disabled: true,
      required: true,
    },
    {
      type: 'select',
      label: '转派人员',

      cascaderItem: [],
      span: 12,
      display: true,
      dicData: [],
      // dicUrl:`/api/v4ward/user/dept-user-list?groupId={{groupId}}`,
      props: {
        label: 'realName',
        value: 'id'
      },
      prop: 'handerId',
      rules: [
        {
          required: true,
          message: '请选择转派人员'
        }
      ],
      disabled: false,
      required: true
    },
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',
      rules: [{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }],
    }
  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 100,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  menuPosition: 'right',
  detail: false,
  tabs: false
};


//   指派表单配置
export const assignFormOption = {
  column: [
    {
      type: 'select',
      label: '服务班组',
      dicData: [
        {
          label: '选项一',
          value: 0
        },
        {
          label: '选项二',
          value: 1
        },
        {
          label: '选项三',
          value: 2
        }
      ],
      cascaderItem: [],
      span: 12,
      display: true,
      props: {
        label: 'label',
        value: 'value'
      },
      prop: '1603791027630_67658',
      disabled: true,
      required: true,
      rules: [
        {
          required: true,
          message: '请选择班组人员'
        }
      ]
    },
    {
      type: 'select',
      label: '转派人员',
      dicData: [
        {
          label: '选项一',
          value: 0
        },
        {
          label: '选项二',
          value: 1
        },
        {
          label: '选项三',
          value: 2
        }
      ],
      cascaderItem: [],
      span: 12,
      display: true,
      props: {
        label: 'label',
        value: 'value'
      },
      prop: '1603791074596_72702',
      rules: [
        {
          required: true,
          message: '请选择转派人员'
        }
      ],
      disabled: false,
      required: true
    },
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      prop: '1604629243436_93844'
    }
  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 100,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  menuPosition: 'right',
  detail: false,
  tabs: false
};


//  转单/接受表单配置

export const robOrderFormOption = {
  column: [
    // {
    //   type: 'select',
    //   label: '服务班组',
    //   dicUrl:'',
    //   formslot:true,
    //   span: 12,
    //   display: true,
    //   props: {
    //     label: 'label',
    //     value: 'value'
    //   },
    //   prop: '1603791027630_67658',
    //   disabled: true,
    //   required: true,
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择班组人员'
    //     }
    //   ]
    // },

    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      rules: [
        {
          required: true,
          message: '请输入备注'
        },
        { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      ],
      formslot: true,
      prop: 'remark',

    }
  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 100,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  menuPosition: 'right',
  detail: false,
  tabs: false
};

// 开始表单配置

export const startOrderFormOption = {
  column: [
    {
      type: 'select',
      label: '项目地点',
      span: 24,
      display: true,
      formslot: true,
      prop: 'areaId',

      required: true,
      rules: [
        {
          required: true,
          message: '请选择项目地点'
        },
        // { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      ]
    },
    {
      label: "预计完成时间",
      prop: "estimateEndTime",
      type: "datetime",
      format: "yyyy-MM-dd HH:mm:ss",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      span: 24,
      // rules: [
      //   {
      //     required: true,
      //     message: '请选择预计完成时间'
      //   },
      //   {
      //     validator: function (rule, value, cb) {
      //       const beforeNow = dayjs(value).isBefore(dayjs())
      //       if (beforeNow) {
      //         cb(new Error('预计完成时间需要大于当前时间'))
      //       } else {
      //         cb()
      //       }
      //     },
      //   },
      // ]
    },
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',

      required: true,
      rules: [
        {
          required: true,
          message: '请填写备注'
        },
        { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      ]
    },
    
    {
      type: 'upload',
      label: '附件',
      span: 24,
      display: true,
      showFileList: true,
      multiple: true,
      limit: 10,
      dataType: 'array',
      propsHttp: {},
      canvasOption: {},
      prop: 'attachList',
      formslot: true,
      drag: true,

    }
  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  menuPosition: 'right',
  detail: false,
  tabs: false
}

// 取消表单配置
export const cancelFormOption = {
  column: [
    {
      type: 'textarea',
      label: '取消原因',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',
      required: true,
      rules: [
        {
          required: true,
          message: '请填写备注'
        },
        { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      ]

    },
    {
      type: 'upload',
      label: '附件',
      span: 24,
      display: true,
      showFileList: true,
      multiple: true,
      limit: 10,
      propsHttp: {},
      canvasOption: {},
      prop: 'attachList',
      fileSize: 500,
      formslot: true,

      drag: true,

    }
  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 100,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false
}

//   评价表单配置

export const evaluateFormOption = {
  column: [


    {
      type: 'textarea',
      label: '评价内容',
      span: 24,
      display: true,
      rules: [
        { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      ],
      prop: 'content'
    },
    {
      type: 'upload',
      label: '附件',
      span: 24,
      display: true,
      showFileList: true,
      multiple: true,
      limit: 10,
      propsHttp: {},
      canvasOption: {},
      prop: 'attachList',
      fileSize: 500,
      formslot: true,

      drag: true,

    }

  ],
  columnCopy: [


    {
      type: 'textarea',
      label: '评价内容',
      span: 24,
      display: true,
      rules: [
        { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      ],
      prop: 'content'
    },
    {
      type: 'upload',
      label: '附件',
      span: 24,
      display: true,
      showFileList: true,
      multiple: true,
      limit: 10,
      propsHttp: {},
      canvasOption: {},
      prop: 'attachList',
      fileSize: 500,
      formslot: true,

      drag: true,

    }

  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false
}


//   回访表单配置

export const visitFormOption = {
  column: [
    {
      type: 'select',
      label: '回访人员',
      dicData: [
        {
          label: '选项一',
          value: 0
        },
        {
          label: '选项二',
          value: 1
        },
        {
          label: '选项三',
          value: 2
        }
      ],
      cascaderItem: [],
      span: 12,
      display: true,
      props: {
        label: 'label',
        value: 'value'
      },
      prop: '1604643627974_53838',
      multiple: false,
      required: true,
      rules: [
        {
          required: true,
          message: '请选择评价对象'
        }
      ],
      placeholder: '请选择回访人员',
      disabled: true
    },
    {
      type: 'select',
      label: '回访形式',
      dicData: [
        {
          label: '选项一',
          value: 0
        },
        {
          label: '选项二',
          value: 1
        },
        {
          label: '选项三',
          value: 2
        }
      ],
      cascaderItem: [],
      span: 12,
      display: true,
      props: {
        label: 'label',
        value: 'value'
      },
      prop: '1604643702755_64326',
      rules: [
        {
          required: true,
          message: '请选择下拉选择器'
        }
      ],
      required: true
    },
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      prop: '1604643755378_14687'
    }
  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false
}

// 延迟
export const delayFormOption = {
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false,
  column: [

    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',
      rules: [{ required: true, message: '请输入备注' }, { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
    },
    {
      type: 'input',
      label: '附件',
      span: 24,
      display: true,
      formslot: true,
      prop: 'attachList',



    }
  ],
}

// 恢复
export const recoverFormOption = {
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false,
  column: [

    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',
      rules: [{ required: true, message: '请输入备注' }, { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
    },


  ],
}


// 完成 finishFormOption
export const finishFormOption = {
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '完成',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false,
  column: [

    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',
      rules: [{ required: true, message: '请输入备注' }, { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
    },
    {
      type: 'input',
      label: '附件',
      span: 24,
      display: true,
      formslot: true,
      prop: 'attachList',


    }
  ],
}
// 报废 scrapFormOption
export const scrapFormOption = {
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false,
  column: [

    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',
      rules: [{ required: true, message: '请输入备注' }, { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
    },
    {
      type: 'input',
      label: '附件',
      span: 24,
      display: true,
      formslot: true,
      prop: 'attachList',


    }
  ],
}
//外委 outsourcingFormOption
export const outsourcingFormOption = {
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false,
  column: [
    {
      type: 'select',
      label: '关联合同',
      span: 24,
      dicData: [],
      display: true,
      props: {
        label: 'contractName',
        value: "contractId"
      },
      prop: 'contractId',
      multiple: true,
      rules: [{ required: true, message: '请选择联合同' }]
    },
    {
      type: 'select',
      label: '合同单位',
      span: 24,
      disabled: true,
      dicData: [],
      display: true,
      props: {
        label: 'partnerName',
        value: "partnerId"
      },
      prop: 'partnerId',


    },
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',
      rules: [{ required: true, message: '请输入备注' }, { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
    },

  ],
}

// 报修
export const repairsFormOption = {
  column: [
    // {
    //   type: 'select',
    //   label: '项目名称',
    //   formslot:true,
    //   span: 8,
    //   display: true,
    //   props: {
    //     label: 'label',
    //     value: 'value'
    //   },
    //   prop: 'projectId',
    //   required: true,
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择项目名称'
    //     }
    //   ]
    // },
    // {
    //   type: 'select',
    //   label: '需求区域',
    //   formslot:true,
    //   span: 12,

    //   display: true,
    //   prop: 'areaId',
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择需求区域'
    //     }
    //   ],
    //   required: true
    // },
    // {
    //   type: 'select',
    //   label: '报单人员',
    //   formslot:true,
    //   span: 12,
    //   display: true,
    //   props: {
    //     label: 'label',
    //     value: 'value'
    //   },
    //   prop: 'requireMainId',
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择报单人员'
    //     }
    //   ],
    //   required: true
    // },
    // {
    //   type: 'select',
    //   label: '需求来源',
    //   dataType:'string',
    //   span: 12,
    //   display: true,
    //   dicUrl:'/api/blade-system/dict/dictionary?code=order_require_source',
    //   props: {
    //     label: 'dictValue',
    //     value: 'dictKey'
    //   },
    //   prop: 'source',
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择报单人员'
    //     }
    //   ],
    //   required: true
    // },
    {
      type: 'datetime',
      label: '期望解决时间',
      span: 12,
      display: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      prop: 'expectStartTime',
      required: true,
      rules: [
        {
          required: true,
          message: '请填写期望解决时间'
        }
      ]
    },
    {
      type: 'select',
      label: '紧急程度',
      dicUrl: '/api/blade-system/dict/dictionary?code=order_urgent_level',

      span: 12,
      display: true,
      props: {
        label: 'dictValue',
        value: 'dictKey'
      },
      prop: 'urgentLevel',
      required: true,
      rules: [
        {
          required: true,
          message: '请选择紧急程度'
        }
      ]
    },
    {
      type: 'select',
      label: '业务模块',
      dicData: [
        {
          label: '选项一',
          value: 0
        },
        {
          label: '选项二',
          value: 1
        },
        {
          label: '选项三',
          value: 2
        }
      ],
      cascaderItem: [],
      span: 12,
      display: false,
      props: {
        label: 'label',
        value: 'value'
      },
      prop: 'moduleJson',
      rules: []
    },
    {
      type: 'textarea',
      label: '工单描述',
      span: 24,
      display: true,
      prop: 'description',
      formslot: true,
      required: true,
      rules: [
        {
          required: true,
          message: '请填写工单描述'
        },
        // { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      ]
    },
    {
      type: 'input',
      label: '附件',
      span: 24,
      display: true,
      formslot: true,
      prop: 'attachList',


    }
  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '提 交',
  emptyBtn: false,
  menuPosition: 'right',
  detail: false,
  tabs: false
}

//协同人
export const settingSynergyOption = {
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: true,
  submitText: '保 存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false,
  column: [
    {
      type: 'select',
      label: '协同班组',
      prop:'group',
      span: 24,
      display: true,
      formslot: true,
    },
    {
      type: 'select',
      label: '协同人',
      span: 24,
      display: true,
      formslot: true,
      prop: 'cooperateList',
    },
  ],
}
